<template>
  <SmallModel :title="t('modals.attachToShipGroup.title')">
    <div class="p-2">
      <p class="pb-3 text-subtext">
        {{ t('modals.attachToShipGroup.description', { count: gameStore.modalData.length }) }}
      </p>
      <FormSelect
        :modelValue="selectedGroup"
        @update:modelValue="selectAndSubmit"
        :options="shipGroupOptions"
      />
    </div>
  </SmallModel>
</template>

<script setup lang="ts">
import { useGameStore } from "@/stores/gameStore.ts";
import SmallModel from "@/components/Interface/Modal/ModelSizes/SmallModel.vue";
import FormSelect from '@/components/Elements/Forms/FormSelect.vue';
import { useShipGroupStore } from "@/stores/shipGroupStore.ts";
import Backend from "@/models/backend.ts";
import { ref, computed } from "vue";
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore();
const shipGroupStore = useShipGroupStore();
const backend = new Backend();

const selectedGroup = ref();

// Computed property for sorted ship groups as options
const shipGroupOptions = computed(() =>
  Array.from(shipGroupStore.shipGroups.values())
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((group) => ({ value: group.id, label: group.name }))
);

const selectAndSubmit = (val: string | number) => {
  selectedGroup.value = val
  submit()
}

const submit = () => {
  backend.attachShipsToGroup(selectedGroup.value, gameStore.modalData).then(() => {
    gameStore.modalType = "";
  });
};
</script>
